import _classCallCheck from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/get.js";
import _inherits from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/elias/Desktop/Bureau/DocUp - vide\u0301o/Site Web /Superprops copie/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BubbleBase } from "./BubbleBase";
export var BubbleDiv = /*#__PURE__*/function (_BubbleBase) {
  _inherits(BubbleDiv, _BubbleBase);

  var _super = _createSuper(BubbleDiv);

  function BubbleDiv() {
    var _this;

    _classCallCheck(this, BubbleDiv);

    _this = _super.call(this);
    _this.selectors = [];
    return _this;
  }

  _createClass(BubbleDiv, [{
    key: "ids",
    get: function get() {
      return this.selectors instanceof Array ? this.selectors.map(function (t) {
        return t.replace("#", "");
      }) : this.selectors.replace("#", "");
    },
    set: function set(value) {
      this.selectors = value instanceof Array ? value.map(function (t) {
        return "#".concat(t);
      }) : "#".concat(value);
    }
  }, {
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(BubbleDiv.prototype), "load", this).call(this, data);

      if (data === undefined) {
        return;
      }

      if (data.ids !== undefined) {
        this.ids = data.ids;
      }

      if (data.selectors !== undefined) {
        this.selectors = data.selectors;
      }
    }
  }]);

  return BubbleDiv;
}(BubbleBase);